import { importAll } from "@/utils";

const imagesContext = require.context("@/assets/images", true, /\.*.$/);
const images = importAll(imagesContext);
const ossDir = "https://cdn-www.angrymiao.com/diy/";

const state = {
  images,
  oss: {
    r1Setup: ossDir + "Cyberboard_Setup_Release_v1.0_0121.zip",
    r2Setup: ossDir + "AM_MasterSetup.zip",
    r2SetupMac: ossDir + "AM_Master.pkg",
    tutorial_cyberboard_cn: ossDir + "tutorial_cyberboard_cn.mp4",
    tutorial_cyberboard_en: ossDir + "tutorial_cyberboard_en.mp4",
    tutorial_hatsu_cn: ossDir + "tutorial_hatsu_cn.mp4",
    tutorial_hatsu_en: ossDir + "tutorial_hatsu_en.mp4",
  },
};

export default {
  namespaced: true,
  state,
};
